// Env-derived config. All `REACT_APP_*` values are read from CRA's env at build time.
// Dev fallbacks let the app boot locally even when .env is missing.
const env = (key, fallback = '') => process.env[key] || fallback;

export const MACHINE_ENVIRONMENT = env('REACT_APP_ENV', 'dev');
export const RECAPTCHA_ENABLED = env('REACT_APP_RECAPTCHA_ENABLED', 'false');
export const SERVER_NAME = env('REACT_APP_SERVER_NAME', 'moovetrax.com');
export const APP_NAME = "MooveTrax"
export const APP_VERSION = "2026102921"

export const IMAGE_CACHE_VERSION = "1.2"
export const WEB_CLIENT_VERSION = "1.3"

export const MILE_KM_RATE = 1.609344

export const BASE_SITE_URL = env('REACT_APP_BASE_SITE_URL', 'http://localhost');
export const BASE_FRONT_URL = env('REACT_APP_BASE_FRONT_URL', 'http://localhost:3000');
export const API_BASE_URL = env('REACT_APP_API_BASE_URL', 'http://localhost:8088');
export const TESLA_API_URL = env('REACT_APP_TESLA_API_URL', 'http://localhost:8099');
export const SOCKET_URL = env('REACT_APP_SOCKET_URL', 'ws://localhost:8000/websocket');
export const SHARE_BASE_URL = env('REACT_APP_SHARE_BASE_URL', 'http://localhost:3000/temporary/');
export const SHARE_RESERVATION_URL = env('REACT_APP_SHARE_RESERVATION_URL', 'http://localhost:3000/trip_access');
export const SHARE_SECONDARY_BASE_URL = env('REACT_APP_SHARE_SECONDARY_BASE_URL', 'http://localhost:3000/second-temporary/');

export const USER_ROLE = {
    USER: 'user',
    BLOGGER: 'blogger'
}

export const INSTALLATION_GUIDE_LINK = "http://install.moovetrax.com/"

export const DEFAULT_GEO_LOCATION = [35.840894, -40.757315]; // [latitude, longitude]
export const DEFAULT_MAP_ZOOM = 16;

export const PAYPAL_PRODUCT_ID = "MoovetraxMonthlyProduct"
export const PAYPAL_PLAN_NAME = "MoovetraxMonthlyPlan"
export const PAYPAL_PLAN_PRICE = 15 //USD //default plan price
export const PAYPAL_ESCROW_PLAN_PRICE = 50 //USD //default plan price

export const MAX_CREDIT_AMOUNT = 15 //max allowed credit amount (if credit is larger than this amount, then user will be forced to the paypal page automatically)
export const MIN_CREDIT_AMOUNT = 5  //minimum amount for user to charge paypal, so if amount is larger than this amount, then user can look "Paypal subscription" button

export const GOOGLE_CHROME_LOGO = "/assets/img/icon-chrome-480.png"
export const GOOGLE_CHROME_URL = "https://apps.apple.com/us/app/google-chrome/id535886823"

export const GPS_ID_PLACEHOLDER = "MT2V000000"
export const USB_GPS_ID_PLACEHOLDER = "3211312220"
export const ICCID_PLACEHOLDER = "002600000"

export const HOME_VIDEO_ID = "v0d-yVgiJwc" //YOUTUBE ID
export const SHRED_TURO_VIDEO_ID = "FnlDmDC7AZs" //YOUTUBE ID
export const SHRED_GEOFENCE_VIDEO_ID = "nbNSWcAmQgs" //YOUTUBE ID
export const SHRED_UPLOAD_VIDEO_ID = "Wiks5TRTzBA" //YOUTUBE ID
export const BLUETOOTH_VIDEO_UPLOAD_ID = "mJ5XPDmtx7Y"
export const MAINT_VIDEO_ID = "IgjoIAFUMMs" //YOUTUBE ID
export const TOLL_VIDEO_ID = "RJmkKwgAzbc" //YOUTUBE ID
export const PAYMENT_VIDEO_ID = "iD6_zjMX4pw" //YOUTUBE ID
export const GEOFENCE_VIDEO_ID = "OCz1Oqc8UDc" //YOUTUBE ID
export const LOCK_SETTING_VIDEO_ID = "AMo_3oM11TI" //YOUTUBE ID
export const SHARE_RESERVATION_VIDEO_ID = "yK-E8wLtEk4" //YOUTUBE ID

export const SORT_KEY_LIST = [
    "Installation",
    "Alphabetically",
    "Balance",
    "Online",
    // "Maintenance",
    "Lock Status",
    "Kill status",
    "",
    "Make",
    "Model",
    "Color",
    "Category",
    "Miles",
    "Vin"
]
export const DEFAULT_SORT_KEY = SORT_KEY_LIST[0]
export const DEFAULT_SORT_ORDER = "asc" //asc, desc

export const MT2V_DC_VOLT_ALERT = 11 //11 V
export const MT2V_DC_VOLT_MIN = 9 //9 V
export const MT2V_DC_VOLT_MAX = 15 //15 V

export const MOVING_SPEED_MIN = 5
export const SHARED_LINK_TEXT_KEY = "[domain][url]" //"{{shared_url}}"

export const DISTANCE_UNIT_LIST = [
    {
        id: 'mile',
        name: 'Miles',
        unit: 'mi',
        speed_unit: 'mi/h'
    },
    {
        id: 'km',
        name: 'Km',
        unit: 'km',
        speed_unit: 'km/h'
    }
]

export const TEST_MT3V_DEVICE_GPS_IDS = ["MT2V000001"]
export const TESLA_PERMISSION_URL = "https://accounts.tesla.com/en_us/account-settings/security?tab=tpty-apps"
export const TESLA_SETUP_URL = "https://www.tesla.com/_ak/t3sla.moovetrax.com"

export const DEVICE_TYPE = {
    MOOVETRAX: "moovetrax",
    SMARTCAR: "smartcar",
    TESLA: "tesla",
    USB: "usb",
    OBD: "obd",
    KILLSWITCH: 'killswitch',
    RLKS: 'rlks',
    KS2G: 'ks2g',
    WATERPROOF: 'waterproof',
    TRACKER_ANDROID: "MobileA",
    TRACKER_IPHONE: "Mobilei",
    OTHER: 'other'
}
export const DEFAULT_LOW_BATTERY_VOLT = 11

export const DEVICE_PAYMENT_STATUS = {
    PAID: 0, // normal access is allowed
    PAYMENT_REQUIRED: 1,
    PAYMENT_REMINDER: 2
}

export const REDIRECT_APP_TIMESTAMP = 2000 // ms

export const REACT_APP_MAPTILER_API_KEY = env('REACT_APP_MAPTILER_API_KEY')

export const APP_GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=com.moovetrax.app&hl=en_US'
export const APP_APPLE_LINK = 'https://apps.apple.com/kw/app/moovetrax/id6738396503'
export const APP_INTRO_PAGE_LINK = 'https://moovetrax.com/apps'

export const SELECTED_LANGUAGE_KEY = 'selectedLanguage'
export const DEFAULT_LANGUAGE = 'en'
export const LANGUAGE_ITEM_LIST = [
    { code: 'en', label: 'English', flag: 'gb' },
    { code: 'es', label: 'Spanish', flag: 'es' },
    { code: 'fr', label: 'French', flag: 'fr' },
];
export const SHARE_ACCESS_TYPE = {
    RESERVATION_ID: "RESERVATION_ID",
    SHARED_URL: "SHARED_URL"
}

export const DEVICE_USAGE_TYPE = {
    RENTAL: "rental",
    DELIVERY: "delivery"
}

export const RESERVATION_ACCESS_STATUS = {
    OFF: 0,
    ON: 1,
    ONE_TIME: 2
}

export const TRIP_ACCESS_STATUS = {
    OFF: 0,
    ON: 1,
}

export const SHARE_ACCESS_LOGIN_TYPE = {
    GUEST_PHONE: "guest_phone",
    HOST_CODE: "host_code",
}

export const INSTALLER_TRACKER_TYPE = {
    TRACKER_ONLY: "trackers_only",
    TRACKER_WITH_LOCKS: "trackers_with_locks"
}

export const SHARE_LINK_PUSH_NOTIFICATION_TYPE = {
    OWNER: "owner",
    CO_HOST: "co-host"
}

export const SMOOTH_TIME_STEP = 30000 // ms 

export const BLOG_STATUS = {
    PENDING: 0,
    APPROVED: 1,
    REJECTED: 2
}

export const SEO_DEFAULT_TITLE = "MooveTrax | Contactless Automation for Car Rental"
export const SEO_DEFAULT_DESCRIPTION = "MooveTrax, Turo GPS, GPS for Turo, Rental Car GPS, Rental Car Tracker, Turo Tracker, Turo Killswitch, Rental Car Killswitch"
export const SEO_DEFAULT_KEYWORDS = "Turo GPS, Turo tracker, movetracks, movetrack, movetrax, moovetrack, moovetrax"

export const DEFAULT_M_SOUND = "honk_multi"

export const NOTIFICATION_SOUND_LIST = [
    { 'name': 'Honk Multi', 'value': 'honk_multi' },
    { 'name': 'Honk Double', 'value': 'honk_double' },
    { 'name': 'Single Horn', 'value': 'single_horn' },
    { 'name': 'Battery', 'value': 'battery' },
    { 'name': 'Hood', 'value': 'hood' },
    { 'name': 'Lock', 'value': 'lock' },
    { 'name': 'Overspeed', 'value': 'overspeed' },
    { 'name': 'Arrive', 'value': 'arrive' },
    { 'name': 'Depart', 'value': 'depart' },
    { 'name': 'No Sound', 'value': 'silence' }
]